/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Add_Recipient_TitleInputs */



/**
* | output |
* | --- |
* | "Add Recipient" |
*
* @param {Speakers_Add_Recipient_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_recipient_title = /** @type {((inputs?: Speakers_Add_Recipient_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Recipient_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un destinataire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Empfänger hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi destinatario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить получателя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar destinatario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加收件人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("受信者を追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राप्तकर्ता को जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar destinatário")
	return /** @type {LocalizedString} */ ("Add Recipient")
});